type Props = {
  /** 項目名。 */
  title: string;
  /** 値。（テキストまたはカスタムUI。） */
  content: React.ReactNode;
};

/** 項目名と値を表示するコンポーネント。 */
export const InfoDisplay = ({ title, content }: Props) => {
  return (
    <div className="flex flex-col gap-[8px]">
      <p className="text-[12px] noto-sans-jp-medium text-primary">{title}</p>
      {typeof content === 'string' ? (
        <p className="text-[16px] noto-sans-jp-medium text-textPrimary">
          {content}
        </p>
      ) : (
        content
      )}
    </div>
  );
};
